var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loading'):(!_vm.changeId)?_c('no-results',{staticStyle:{"margin":"auto"},attrs:{"title":"No results","message":"There are no changes."}}):_c('div',[_c('change-snapshot',{attrs:{"site-id":_vm.siteId,"change-id":_vm.changeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }